import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const CountryProductGrid = ({
  heading,
  products,
  countryUrl,
}) => {

  const [selectedCard, setSelectedCard] = useState(null);

  const navigate = useNavigate();

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const cardAnim = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut"
      }
    }
  };

  return (
    <>
      <section className="card-section container">

        {/* HEADING */}

        <motion.h2
          className="section-heading"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {heading}
        </motion.h2>

        {/* CARDS */}

       <motion.div
  className={`cards-grid ${
    products.length === 2
      ? "two-cards-grid"
      : ""
  }`}
  variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>

          {products.map((card) => (

            <motion.div
              key={card.id}
              className="card"
              variants={cardAnim}
              whileHover={{ y: -8 }}
              whileTap={{ scale: 0.98 }}
              onClick={() =>
                setSelectedCard(card)
              }
            >

              <div className="card-content">

                {/* IMAGE */}

                <div className="image-wrapper">

                  <motion.img
                    src={card.img}
                    alt={`${card.cardTitle} | Iris Impulse India Pvt. Ltd.`}
                    className="card-image"
                    whileHover={{
                      scale: 1.05
                    }}
                    transition={{
                      duration: 0.5
                    }}
                  />

                </div>

                <h3>
                  {card.cardTitle}
                </h3>

                <p>
                  {card.cardDescription}
                </p>

              </div>

            </motion.div>

          ))}

        </motion.div>

        {/* MODAL */}

        <AnimatePresence>

          {selectedCard && (

            <motion.div
              className="modal-overlay"
              onClick={() =>
                setSelectedCard(null)
              }
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{
                duration: 0.3
              }}
            >

              <motion.div
                className="modal-content"
                onClick={(e) =>
                  e.stopPropagation()
                }
                initial={{
                  opacity: 0,
                  scale: 0.9,
                  y: 40
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                  y: 0
                }}
                exit={{
                  opacity: 0,
                  scale: 0.9,
                  y: 40
                }}
                transition={{
                  duration: 0.4,
                  ease: "easeOut"
                }}
              >

                {/* CLOSE */}

                <div className="modal-header">

                  <button
                    className="modal-close"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedCard(null);
                    }}
                  >
                    ×
                  </button>

                </div>

                {/* IMAGE */}

                <img
                  src={
                    selectedCard.largeImg ||
                    selectedCard.img
                  }
                  alt={`${selectedCard.cardTitle} | Iris Impulse India Pvt. Ltd.`}
                />

                {/* CONTENT */}

                <h3>
                  {selectedCard.cardTitle}
                </h3>

                <h4>
                  {selectedCard.cardDescription}
                </h4>

                {selectedCard.introPara && (

                  <p className="section-text">
                    {selectedCard.introPara}
                  </p>

                )}

                {/* BTN */}

                <motion.button
                  className="outline-btn"
                  whileHover={{
                    scale: 1.05
                  }}
                  whileTap={{
                    scale: 0.97
                  }}
                  onClick={() =>
                    navigate(
                      `/${countryUrl}/${selectedCard.url}`
                    )
                  }
                >
                  LEARN MORE
                </motion.button>

              </motion.div>

            </motion.div>

          )}

        </AnimatePresence>

      </section>
    </>
  );
};

export default CountryProductGrid;